import React, { useRef, useState } from "react";
import { Chart } from "react-google-charts";

const data = [
  ["Time", "Temperature", "Humidity"],
  [new Date("2025-07-27T00:00:00"), 20, 45],
  [new Date("2025-07-27T01:00:00"), 22, 48],
  [new Date("2025-07-27T02:00:00"), 21, 46],
  [new Date("2025-07-27T03:00:00"), 23, 47],
  [new Date("2025-07-27T04:00:00"), 24, 49],
];

const options = {
  title: "Environment Variables",
  hAxis: { title: "Time", format: "HH:mm" },
  vAxis: { title: "Value" },
  tooltip: { trigger: "none" },
  legend: { position: "bottom" },
  focusTarget: "category",
  enableInteractivity: false,
};

const GChart = () => {
  const chartRef = useRef(null);
  const containerRef = useRef(null);
  const [hoverInfo, setHoverInfo] = useState(null);

  const handleMouseMove = (e) => {
    const wrapper = chartRef.current;
    if (!wrapper) return;

    const chart = wrapper.getChart();
    const cli = chart.getChartLayoutInterface();
    const chartArea = cli.getChartAreaBoundingBox();
    const rect = containerRef.current.getBoundingClientRect();

    const mouseX = e.clientX - rect.left;
    if (mouseX < chartArea.left || mouseX > chartArea.left + chartArea.width) {
      setHoverInfo(null);
      return;
    }

    const axisValue = cli.getHAxisValue(mouseX);
    const index = findClosestIndex(axisValue);
    if (index !== null) {
      const pointX = cli.getXLocation(data[index + 1][0]); // skip header
      setHoverInfo({
        x: pointX,
        time: data[index + 1][0],
        temp: data[index + 1][1],
        hum: data[index + 1][2],
      });
    } else {
      setHoverInfo(null);
    }
  };

  const findClosestIndex = (axisVal) => {
    const target = axisVal instanceof Date ? axisVal.getTime() : axisVal;
    let minDiff = Infinity;
    let minIndex = null;
    for (let i = 1; i < data.length; i++) {
      const d = data[i][0];
      const v = d instanceof Date ? d.getTime() : d;
      const diff = Math.abs(v - target);
      if (diff < minDiff) {
        minDiff = diff;
        minIndex = i - 1;
      }
    }
    return minIndex;
  };

  return (
    <div style={{ width: "100%", marginTop: "50px" }}>
    <div
      ref={containerRef}
      onMouseMove={handleMouseMove}
      style={{
        position: "relative",
        // top: "100px",
        width: "100%",
        height: "400px",
        border: "1px solid red",
      }}>
      <Chart
        chartType="LineChart"
        width="100%"
        height="100%"
        data={data}
        options={options}
        getChartWrapper={(c) => (chartRef.current = c)}
      />

      {hoverInfo && (
        <>
          {/* Label */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: hoverInfo.x,
              transform: "translateX(-50%)",
              background: "rgba(255,255,255,0.9)",
              padding: "2px 8px",
              fontSize: "12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              pointerEvents: "none",
              whiteSpace: "nowrap",
            }}>
            {hoverInfo.time.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}{" "}
            | 🌡 {hoverInfo.temp}°C | 💧 {hoverInfo.hum}%
          </div>

          {/* Vertical line */}
          {/* <div
            style={{
              position: "absolute",
              top: 30,
              bottom: 30,
              left: hoverInfo.x,
              width: "1px",
              background: "#888",
              pointerEvents: "none",
            }}
          /> */}
        </>
      )}
    </div>
    </div>
  );
};

export default GChart;
